import { render, staticRenderFns } from "./OrgAdd.vue?vue&type=template&id=b2153610&scoped=true"
import script from "./OrgAdd.vue?vue&type=script&lang=js"
export * from "./OrgAdd.vue?vue&type=script&lang=js"
import style0 from "./OrgAdd.vue?vue&type=style&index=0&id=b2153610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2153610",
  null
  
)

export default component.exports